// Layout.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppFloatingButton from '../WhatsAppButton';
const Layout = ({ children }) => {
    const location = useLocation();

    const getActiveTab = () => {
        switch (location.pathname) {
            case '/refer-earn':
                return 0;
            case '/industry-specific-course':
                return 1;
            case '/partner-course':
                return 2;
            case '/free-course':
                return 3;
            case '/premium-course':
                return 4;
            case '/more':
                return 5;
            default:
                return null;
        }
    };

    return (
        <div>
            <Header activeTab={getActiveTab()} />
            
            <main style={{ minHeight: '80vh' }}>
                {children}
            </main>

            {/* Floating WhatsApp Button */}
            <WhatsAppFloatingButton />

            <Footer />
        </div>
    );
};

export default Layout;
